/* sx-back.js (16 Oct): pressing back lands the shopper exactly where they left, with the same filters.
   Filters already live in the address (?sx=, sort_by, page), so the page comes back filtered; this file puts the scroll back:
   (1) the page itself, including a filtered grid that is built after load in chunks (the browser cannot reach that spot alone),
   (2) the sideways rows on the homepage (each row's swipe position).
   Nothing is restored on a fresh visit or a reload, and it stops the moment the shopper scrolls or taps. */
(function(){
  'use strict';
  var s; try{s=window.sessionStorage;s.setItem('sxback:t','1')}catch(e){return}
  var KEY='sxback:v2:', MAXAGE=30*60*1000;
  function key(){return KEY+location.pathname+location.search}
  function rows(){return [].slice.call(document.querySelectorAll('.sxh-trk'))}
  function save(){
    try{s.setItem(key(),JSON.stringify({y:Math.round(window.scrollY),x:rows().map(function(t){return Math.round(t.scrollLeft)}),t:Date.now()}))}catch(e){}
  }
  window.addEventListener('pagehide',save);
  document.addEventListener('click',function(e){var a=e.target.closest&&e.target.closest('a[href]');if(a)save()},true);

  var nav=null; try{nav=performance.getEntriesByType('navigation')[0]}catch(e){}
  if(!(nav&&nav.type==='back_forward')) return;
  var rec=null; try{rec=JSON.parse(s.getItem(key())||'null')}catch(e){}
  if(!rec||Date.now()-rec.t>MAXAGE) return;

  var filtered=/[?&]sx=/.test(location.search);
  var y=rec.y||0, xs=rec.x||[], t0=Date.now(), stop=false;
  // the shopper takes over: stop moving the page
  function quit(){stop=true}
  ['wheel','touchstart','keydown','mousedown'].forEach(function(ev){window.addEventListener(ev,quit,{passive:true,once:true})});
  if(filtered){try{history.scrollRestoration='manual'}catch(e){}}

  function start(){
    var ok=0, rowsDone=!xs.some(function(v){return v>0});
    (function tick(){
      if(stop) return;
      // sideways rows: put each back once it is wide enough (rows add more cards after load)
      if(!rowsDone){
        var tr=rows(), all=true;
        xs.forEach(function(v,i){var t=tr[i];if(!v)return;if(!t){all=false;return}
          if(t.scrollWidth-t.clientWidth>=v){if(Math.abs(t.scrollLeft-v)>2){t.scrollLeft=v;t.dispatchEvent(new Event('scroll'))}}else{all=false;t.scrollLeft=t.scrollWidth}});
        rowsDone=all;
      }
      // the page: wait until it is tall enough, then hold the spot for a few ticks while images settle
      if(y>0){
        var room=document.documentElement.scrollHeight-window.innerHeight;
        if(room>=y){
          if(Math.abs(window.scrollY-y)>2) window.scrollTo(0,y);
          ok++;
        }else if(filtered){
          var g=document.getElementById('product-grid');
          if(g&&g.children.length) window.scrollTo(0,document.documentElement.scrollHeight); // pulls in the next chunk of the filtered grid
        }
      }else ok=99;
      if((ok>=4&&rowsDone)||Date.now()-t0>8000) return;
      setTimeout(tick,120);
    })();
  }
  // unfiltered pages: the browser usually gets it right; only step in if it missed after load
  if(filtered){ if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',start); else start(); }
  else { var go=function(){setTimeout(start,60)}; if(document.readyState==='complete') go(); else window.addEventListener('load',go); }
})();
